<template>
  <div>
    <ve-line :data="chartData"></ve-line>
  </div>
</template>

<script>

export default {
  data() {
    return {
      chartData: {
        columns: ['日期', '電壓'],
        rows: [],
      },
    };
  },
  methods: {
    timeStampconver(timeStamp) {
      // const unix_timestamp = 1549312452;
      // Create a new JavaScript Date object based on the timestamp
      // multiplied by 1000 so that the argument is in milliseconds, not seconds.
      const date = new Date(timeStamp * 1000);
      // Hours part from the timestamp
      const hours = date.getHours();
      // Minutes part from the timestamp
      const minutes = `0${date.getMinutes()}`;
      // Seconds part from the timestamp
      const seconds = `0${date.getSeconds()}`;

      // Will display time in 10:30:23 format
      const formattedTime = `${hours}:${minutes.substr(-2)}:${seconds.substr(-2)}`;
      console.log(formattedTime);
      return formattedTime;
    },
    getData() {
      const filename = 'data';
      fetch(`${filename}.json`)
        .then((r) => r.json())
        .then((json) => {
          const data = json;
          data.batteryPower.forEach((element) => {
            const temp = { 日期: this.timeStampconver(element.t), 電壓: element.b };
            this.chartData.rows.push(temp);
          });
        },
        (response) => {
          console.log('Error loading json:', response);
        });

      console.log(this.chartData);
    },
  },
  beforeMount() {
    this.getData();
  }
  ,
};
</script>
